module.exports = __webpack_public_path__ + "e4c3ebd4ec163abb44efbe9000ac7431.svg";